export const getDateKey = (date: string | null | undefined): string => {
  if (!date) {
    return '';
  }
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) {
    return '';
  }
  return dateObj.toISOString().split('T')[0];
};

export const formatDateHeader = (date: string | null | undefined): string => {
  if (!date) {
    return '';
  }
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) {
    return '';
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dateOnly = new Date(dateObj);
  dateOnly.setHours(0, 0, 0, 0);

  const diffTime = dateOnly.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  let prefix = '';
  if (diffDays === 0) {
    prefix = 'Hôm nay';
  } else if (diffDays === 1) {
    prefix = 'Ngày mai';
  } else if (diffDays === -1) {
    prefix = 'Hôm qua';
  } else if (diffDays > 1) {
    prefix = `+${diffDays} ngày`;
  } else {
    prefix = `${diffDays} ngày`;
  }

  const day = dateObj.getDate().toString().padStart(2, '0');
  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
  const year = dateObj.getFullYear();

  return `${prefix} - ${day}/${month}/${year}`;
};

export const isTodayDate = (date: string | null | undefined): boolean => {
  if (!date) {
    return false;
  }
  const dateObj = new Date(date);
  if (isNaN(dateObj.getTime())) {
    return false;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dateOnly = new Date(dateObj);
  dateOnly.setHours(0, 0, 0, 0);
  return dateOnly.getTime() === today.getTime();
};

export const getDefaultProgressDateRange = () => {
  const today = new Date();
  const from = new Date(today);
  from.setDate(today.getDate() - 14);
  const to = new Date(today);
  to.setDate(today.getDate() + 14);
  return { from, to };
};
